(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  function setPredpredaj() {
    var button = document.querySelector('[data-preorder-tag="true"]');
    if (!button) return;

    var text = button.querySelector('.text');
    if (text) text.textContent = 'Predpredaj';
  }

  setPredpredaj();

  document.addEventListener('click', function () {
    setTimeout(setPredpredaj, 0);
    setTimeout(setPredpredaj, 100);
  });

  document.addEventListener('change', function () {
    setTimeout(setPredpredaj, 0);
    setTimeout(setPredpredaj, 100);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
    jQuery(document).ready(function ($) {
        $('.btn-close').on('click', function(){
        $(this).parents('.parent-close').slideUp();
        })
    });

  } catch(e) { console.error(e); }
})();
})();
